import RebateList from './index';

export default { path: '/home/rebateList', component: RebateList };
